var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewfolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00129 11.2002L8.00129 8.93747M8.00129 8.93747L8.00129 6.67473M8.00129 8.93747L5.73855 8.93748M8.00129 8.93747L10.264 8.93748M1.60192 11.6942L1.60198 5.61132C1.60198 5.00204 1.60176 4.13422 1.60156 3.50585C1.60143 3.0639 1.95965 2.70605 2.40159 2.70605H6.21374L8.05709 4.67515H13.6013C14.0431 4.67515 14.4013 5.03333 14.4013 5.47517L14.4011 11.6943C14.4011 12.5779 13.6847 13.2942 12.8011 13.2942L3.20192 13.2942C2.31826 13.2942 1.60191 12.5779 1.60192 11.6942Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewfolder);
export default __webpack_public_path__ + "static/media/newfolder.7578b985dbf2c17768fe38190ebc943d.svg";
export { ForwardRef as ReactComponent };